<template>
	<main id="subPage" class="admin">
		<!-- 카테고리 -->
        <section id="category">
			<h2>관리자 메뉴</h2>
			<ul class="breadCrumb">
				<li class="home"></li>
				<li class="web">
					<p class="pageTxt">관리자 메뉴</p>
					<ul class="depth">
						<li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
						<li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
					</ul> 
				</li>
                <li class="web">
					<p class="pageTxt">팝업/배너관리</p>
					<ul class="depth">
						<li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
						<li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
                        <li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
                        <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
						<li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
					</ul> 
				</li>
                <li>
					<p class="pageTxt">배너관리</p>
					<ul class="depth">
						<li><router-link to="/popuplist" title="팝업관리">팝업관리</router-link></li>
						<li><router-link to="/bannerlist" title="배너관리">배너관리</router-link></li>
					</ul> 
				</li>
			</ul>
        </section>

		<!-- 컨텐츠 영역 -->
		<section id="content">
			<div class="inner">
				<h3 class="pageTitle">배너 관리</h3>
                <article>
                    <div class="searchArea">
                        <div class="total">
                            총<span>{{bannerCnt}}</span>건
                        </div>
                        <div class="searchBox">
                            <div>
                                <select id="" v-model="searchCondition" title="검색영역 선택">
                                    <option value="1">제목</option>
                                    <option value="2">내용</option>
                                    <option value="3">제목+내용</option>
                                </select>
                                <input type="text" v-model="searchKeyword" @keyup.enter="findBanner" title="검색어 입력" placeholder="검색어입력">
                            </div>
                            <button type="button" @click="findBanner" class="btn dkGray">검색</button>
                        </div>
                    </div>
                    <div class="scroll-table">
						<i class="v-scroll"></i>
                        <div class="table vertical-table">
                            <table>
                                <caption>배너 관리 테이블</caption>
                                <colgroup>
                                    <col style="width: 10%;">
									<col style="width: 10%;">
                                    <col style="width: auto;">
                                    <col style="width: 20%;">
                                    <col style="width: 15%;">
                                    <col style="width: 15%;">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th scope="col">번호</th>
                                        <th scope="col">순서</th>
                                        <th scope="col">제목</th>
                                        <th scope="col">링크</th>
                                        <th scope="col">등록일</th>
                                        <th scope="col">사용여부</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="nodate" v-if="nodata">
                                        <td colspan="6" >조회된 데이터가 없습니다.</td>
                                    </tr>
                                    <tr v-for="(item,index) in calData" :key="index" @click="view(item.bannerId)">
                                        <td>{{ ( listData.length - index ) - ( (curPageNum-1) * dataPerPage ) }}</td>
										                    <td>{{ item.bannerOrder }}</td>
                                        <td><p class="title">{{ item.title }}</p></td>
                                        <td>{{ item.linkUrl }}</td>
                                        <td>{{ item.regDttm | ptDateFormat }}</td>
                                        <td v-if="item.useYn === 'Y'">사용함</td>
							                          <td v-else>사용안함</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!--btnArea-->
                    <div class="btnArea txt-right">
                        <button type="button" class="btn border" @click="$router.push('bannerenrollment')">등록</button>
                    </div>
                    
                    <!-- 페이지네이션 -->
                    <v-pagination v-model="curPageNum" :length="numOfPages"></v-pagination>
                </article>
            </div>
        </section>
	</main>
</template>

<script>
import axios from "../../../util/axios";

export default {
	data(){
		return{
            listData     : [],
			curPageNum   : 1,
			dataPerPage  : 10,
            searchCondition: "1",
            searchKeyword: "",
            nodata: true,
            bannerCnt: 0,
		}
	},
	
	mounted(){
        this.findBanner();
	},

    methods: {
        async findBanner() {
            const res = await axios('get', "/api/admin/banner/list.json", {
                searchCondition: this.searchCondition,
                searchKeyword  : this.searchKeyword,
            });
            const data = res.data.bannerList;
            if (!data || data.length <= 0) {
                this.listData = [];
                this.nodata = true;
                this.bannerCnt = 0;
                return;
            }
            this.listData = data;
            this.nodata = false;
            this.bannerCnt = this.listData.length;

            this.curPageNum = 1;
        },

        view(bannerId) {
			this.$router.push({
				path  : 'bannerview',
				query : { bannerId : bannerId }
			});
		},
	},

    computed: {
    startOffset() {
      return (this.curPageNum - 1) * this.dataPerPage;
    },
    endOffset() {
      return this.startOffset + this.dataPerPage;
    },
    numOfPages() {
      return Math.ceil(this.listData.length / this.dataPerPage);
    },
    calData() {
      if (this.listData.length < 0) {
        return;
      }
        return this.listData.slice(this.startOffset, this.endOffset);
    },
  },
}
</script>

